import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Tengo que dejar el café para siempre?',
    a: 'No, solo durante la fase de reprogramación inicial para dejar que los tejidos sanen. Una vez que la válvula esté fortalecida, el protocolo te guía para reintroducir alimentos de forma estratégica.'
  }, {
    q: '¿Es seguro si tengo hernia hiatal?',
    a: 'Sí. El protocolo se enfoca en el fortalecimiento muscular que es vital para quienes tienen hernia hiatal. Los ejercicios de respiración técnica del Mecanismo Cardias-Lock™ están diseñados específicamente para esta condición.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al instante. Una vez confirmado el pago por Mercado Pago, recibís un mail con el acceso al PDF. Sin plataformas, sin claves adicionales. Podés leerlo en cualquier dispositivo.'
  }, {
    q: '¿Necesito dejar el omeprazol para aplicar el protocolo?',
    a: 'No. El protocolo funciona de forma complementaria a la medicación. Incluye una guía para reducir la dependencia gradualmente de forma segura, pero nunca reemplaza la indicación de tu médico.'
  }, {
    q: '¿En cuánto tiempo voy a ver resultados?',
    a: 'El protocolo está diseñado para generar cambios perceptibles en 72 horas. La mayoría reporta menor ardor nocturno y mejor digestión en los primeros 3 días.'
  }, {
    q: '¿Qué pasa si lo pruebo y no funciona para mí?',
    a: 'Tenés 7 días de garantía completa. Si sentís que el protocolo no cumplió lo que prometió, escribís un correo y te devolvemos el 100% de tu dinero. Sin preguntas, sin demoras.'
  }, {
    q: '¿El Protocolo reemplaza la consulta médica?',
    a: 'No. Es material de educación y apoyo para personas con reflujo. No es diagnóstico médico ni reemplaza el seguimiento de un profesional, especialmente en casos con complicaciones o medicación activa.'
  }, {
    q: '¿Funciona si tengo gastritis crónica o úlcera?',
    a: 'Sí. El protocolo está diseñado para personas con reflujo gastroesofágico, gastritis crónica, hernia hiatal e incluso esófago de Barrett. Los principios de fortalecimiento de la válvula aplican en todos estos casos. Si tenés úlcera activa, consultá con tu médico antes de comenzar.'
  }, {
    q: '¿Y los remedios caseros como vinagre de manzana, bicarbonato o sábila?',
    a: 'Muchas personas prueban vinagre de manzana, bicarbonato de sodio, sábila, jengibre, cúrcuma y otros remedios. Algunos dan alivio momentáneo, pero ninguno fortalece la válvula Cardias. El protocolo ataca la causa mecánica, no solo el síntoma.'
  }, {
    q: '¿Sirve si soy prediabético, hipertenso o tomo otros medicamentos?',
    a: 'El protocolo es compatible con la mayoría de condiciones y medicaciones. No requiere suplementos ni sustancias que interfieran con tu tratamiento actual. Siempre recomendamos informar a tu médico sobre cualquier cambio en tu rutina de salud.'
  }];
  return <section id="faq" className="py-[100px] bg-gradient-to-b from-[#120806] to-[#1a0f08]" data-id="element-174">
      <div className="container-custom" data-id="element-175">
        <SectionHeader eyebrow="Preguntas frecuentes" title={<>
              Todo lo que necesitás
              <br data-id="element-177" />
              <span className="text-gold" data-id="element-178">saber antes de comprar</span>
            </>} data-id="element-176" />

        <div className="max-w-[720px] mx-auto mt-[60px]" data-id="element-179">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className="border-b border-gold/15" data-id="element-180">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full bg-transparent border-none text-white text-[15px] font-medium text-left py-5 cursor-pointer flex justify-between items-center gap-4 transition-colors hover:text-gold font-sans" data-id="element-181">
                  {faq.q}
                  <div className={`w-5 h-5 rounded-full border border-gold/40 flex items-center justify-center shrink-0 text-gold transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-182">
                    <Plus className="w-3.5 h-3.5" data-id="element-183" />
                  </div>
                </button>
                <AnimatePresence data-id="element-184">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-185">
                      <p className="text-[14px] text-gray leading-[1.7] pb-5" data-id="element-186">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}